import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormCheck,
  InputGroup,
  ProgressBar,
  Row,
  Spinner,
} from "react-bootstrap";
import CustomRadioButton from "../../../../../../../components/CustomRadioButton";
import Flatpickr from "react-flatpickr";
import { Icon } from "@iconify/react/dist/iconify.js";
import { getCalendarSvg } from "../../../../../../../svgIcons/CalenderIcons";
import Select, { components } from "react-select";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { formatDate } from "../../../../../../../helpers/dateFormatter";
import { toast } from "react-toastify";
import {
  usePostPriceScheduleExclusiveMutation,
  useUpdateProductPriceScheduleMutation,
} from "../../../../../../../rtk-query/slices/createProduct/ProductScheduleAndPricing/productScheduleAndPricingSlice";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "../../../../../../../assets/delete-item-icon.svg";
import { v4 as uuidv4 } from "uuid"; // Import UUID
import { parseFormattedDate } from "../../../../../../../helpers/dateFormatter";
import { generateTimeOptions } from "../../../../../../../helpers/timeFormatter";

// Example time options
const timeOptions = generateTimeOptions();

const numberOptions = Array.from({ length: 99 }, (_, i) => ({
  value: i + 1,
  label: i + 1,
}));

const validationSchema = Yup.object().shape({
  startDate: Yup.date().required("Start date is required"),
  daysApply: Yup.array()
    .min(1, "Please select at least one day")
    .required("Please select at least one day"),
});

const ByVehicleModal = ({
  setStep,
  handleClose,
  weeklyData,
  productDetail,

  productOptionId,
  scheduleData,
  schedule,
}) => {
  const navigate = useNavigate();
  const [updateProductPriceSchedule, { isLoading }] =
    useUpdateProductPriceScheduleMutation();
  const flatpickrRef = useRef();
  const flatpickrRef2 = useRef();
  const [selectedDateFilter, setSelectedDateFilter] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [selectedDays, setSelectedDays] = useState(false);
  const [liveAvailability, setLiveAvailability] = useState(
    productDetail?.live_availability === 1 ? true : false
  );
  const [discount, setDiscount] = useState(
    productDetail?.product_options[0]?.product_price_schedules[0]
      ?.product_schedule_prices[0]?.discount_percent
      ? parseInt(
          productDetail?.product_options[0]?.product_price_schedules[0]
            ?.product_schedule_prices[0]?.discount_percent
        )
      : 12
  );
  // Values for days field
  const handleDayClick = (dayId, values, setFieldValue) => {
    const updatedDays = values?.daysApply?.includes(dayId)
      ? values.daysApply.filter((id) => id !== dayId)
      : [...values.daysApply, dayId];
    setFieldValue("daysApply", updatedDays);
    if (values?.daysApply?.includes(dayId)) {
      setSelectedDays(false);
    }
    if (updatedDays.length === 7) {
      setSelectedDays(true);
    }
  };

  const handleSelectAllDays = (values, setFieldValue) => {
    const allDayIds = weeklyData.data.map((day) => day.day_id);
    setFieldValue("daysApply", allDayIds);
  };

  const handleDeselectAllDays = (values, setFieldValue) => {
    const allDayIds = weeklyData.data.map((day) => day.day_id);
    if (allDayIds.every((dayId) => values.daysApply.includes(dayId))) {
      setFieldValue("daysApply", []);
    }
  };

  // Time slot selection
  // Function to convert the array
  const convertTimeSlots = (timeSlots) => {
    if (timeSlots.length === 0) {
      // Return a default object if the array is empty
      return [
        {
          id: uuidv4(),
          start_time: "",
          end_time: "",
        },
      ];
    }

    // Map each slot to the desired format
    return timeSlots.map((slot) => ({
      id: uuidv4(), // Generate a new UUID
      start_time: slot.product_start_time,
      end_time: slot.product_end_time,
    }));
  };

  const [timeSlots, setTimeSlots] = useState(
    scheduleData?.product_schedule_time_slots
      ? convertTimeSlots(scheduleData?.product_schedule_time_slots)
      : [{ id: uuidv4(), start_time: "", end_time: "" }]
  );

  const [timeError, setTimeError] = useState("");

  const handleStartTimeChange = (id, selectedOption) => {
    const newTimeSlots = timeSlots.map((slot) =>
      slot.id === id ? { ...slot, start_time: selectedOption.value } : slot
    );
    setTimeSlots(newTimeSlots);
  };

  // Handle removing a time slot by id
  const handleRemoveTimeSlot = (idToRemove) => {
    const updatedTimeSlots = timeSlots.filter((slot) => slot.id !== idToRemove);
    setTimeSlots(updatedTimeSlots); // Update state after removal
  };

  const handleEndTimeChange = (index, selectedOption) => {
    setTimeError(""); // Clear any existing error
    const newTimeSlots = [...timeSlots]; // Create a copy of the existing time slots

    // Update the end_time for the current index
    newTimeSlots[index].end_time = selectedOption.value;
    setTimeSlots(newTimeSlots); // Update the state with the modified time slots

    // Check if the next index already has a time slot
    if (!newTimeSlots[index + 1]) {
      addTimeSlot(); // Add a new time slot if the next index doesn't exist
    }
  };

  const addTimeSlot = () => {
    setTimeSlots([
      ...timeSlots,
      { id: uuidv4(), start_time: "", end_time: "" },
    ]);
  };

  const validateTimeSlots = () => {
    let valid = true;
    setTimeError(""); // Clear previous errors

    // for (const [index, slot] of timeSlots.entries()) {
    //   if (slot.start_time && !slot.end_time) {
    //     setTimeError(
    //       `Start time ${slot.start_time} at slot ${
    //         index + 1
    //       } does not have a corresponding end time.`
    //     );
    //     return false; // Exit early since validation failed
    //   }
    // }

    return valid;
  };

  const getEndTimeOptions = (startTime) => {
    return timeOptions.filter((option) => option.value > startTime);
  };

  // Max pax table
  const [rows, setRows] = useState(() => {
    // Extract values from the first item of the array
    const defaultValues = {
      maxPax: "",
      retailPrice: "",
      discountPrice: "",
      commission: "",
      yourShare: "",
      error: "",
    };

    if (
      Array.isArray(scheduleData?.product_schedule_prices) &&
      scheduleData?.product_schedule_prices.length > 0
    ) {
      const firstItem = scheduleData?.product_schedule_prices[0];

      return [
        {
          maxPax: firstItem.max_quantity || defaultValues.maxPax,
          retailPrice: firstItem.retail_price || defaultValues.retailPrice,
          discountPrice: "",
          commission: "", // Set default or derive if needed
          yourShare: "", // Set default or derive if needed
          error: defaultValues.error,
        },
      ];
    }

    // Return default values if the array is empty or not provided
    return [defaultValues];
  });

  const [formError, setFormError] = useState("");

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        maxPax: "",
        retailPrice: "",
        discountPrice: "",
        commission: "",
        yourShare: "",
        error: "",
      },
    ]);
  };

  const handleChange = (index, field, value) => {
    setFormError("");
    const updatedRows = [...rows];
    updatedRows[index][field] = value;

    // Clear any existing errors when fields are modified
    if (field === "maxPax" || field === "retailPrice") {
      updatedRows[index].error = "";
    }

    setRows(updatedRows);
  };

  const validateMaxPax = () => {
    let hasValidRow = false;
    let validRow = true;
    setFormError(""); // Reset the form error before validation
    rows?.forEach((row) => {
      if (row.maxPax && !row.retailPrice) {
        validRow = false;
      }

      if (row.maxPax && row.retailPrice) {
        hasValidRow = true; // At least one valid row exists
      }
    });
    if (!validRow) {
      setFormError("Retail price is required if max pax is entered");
    }

    if (!hasValidRow) {
      setFormError("Please add max pax value.");
    }
    if (!validRow || !hasValidRow) {
      return false;
    } else {
      return true;
    }
    // return true; // Validation passed
  };

  const convertArrayToPriceCategories = (array) => {
    return array
      .filter((item) => item.maxPax) // Filter out empty objects
      .map((item) => ({
        price_age_category_id: 4,
        retail_price: parseFloat(item.retailPrice) || 0, // Convert retailPrice to a numbers
        discount_percent: discount,
        discount_price: parseFloat(
          (item.retailPrice - (item.retailPrice * discount) / 100).toFixed(2)
        ),
        max_quantity: parseInt(item.maxPax, 10) || 0, // Convert maxPax to a number
      }));
  };

  return (
    <Formik
      initialValues={{
        startDate: scheduleData?.schedule_start_date
          ? new Date(parseFormattedDate(scheduleData?.schedule_start_date))
          : null,
        endDate: scheduleData?.schedule_end_date
          ? new Date(parseFormattedDate(scheduleData?.schedule_end_date))
          : null,
        daysApply: scheduleData?.product_schedule_days
          ? scheduleData?.product_schedule_days.map((item) => item.day_id)
          : [],
      }}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        try {
          console.log("submitted", "on submit");

          // const validPax = validateMaxPax();
          const validPax = true;
          const validDay = validateTimeSlots();
          if (validPax) {
            let data = {
              product_id: schedule?.product_id,
              product_option_id: scheduleData?.product_option_id,
              option_title: schedule?.product_option_title,
              option_schedule_id: scheduleData?.id,
              product_price_unit: schedule?.product_option_type,
              max_capacity_per_booking: parseInt(
                schedule?.product_option_max_capacity_per_booking
              ),
              start_date: formatDate(values.startDate),
              end_date: values.endDate ? formatDate(values.endDate) : null,
              schedules_days: values.daysApply,
              time_type: "FixedSlots",
              price_age_categories: convertArrayToPriceCategories(rows),
              start_time: timeSlots
                .map((slot) => slot.start_time)
                .filter((time) => time !== ""),
              live_availability: liveAvailability ? 1 : 0,
              // end_time: timeSlots
              //   .map((slot) => slot.end_time)
              //   .filter((time) => time !== ""),
            };
            if (productOptionId) {
              data = { ...data, product_option_id: productOptionId };
            }
            const lang = localStorage.getItem("productLanguage")
              ? localStorage.getItem("productLanguage")
              : "en";
            const response = await updateProductPriceSchedule({
              ...data,
              lang: lang,
            });

            if (response?.data?.status) {
              toast.success(response?.data?.message, {
                position: "top-center",
                autoClose: 3000,
              });
              handleClose();
              setStep(1);
              // setStepOneData(null);
            }
            if (response?.error) {
              const errors = response?.error?.data?.errors;
              if (response?.error?.status === 401) {
                localStorage.removeItem("DODLoginToken");
                toast.error(response?.error?.data?.message, {
                  position: "top-center",
                  autoClose: 3000,
                });
                navigate("/login");
              } else if (errors) {
                for (const field in errors) {
                  if (errors.hasOwnProperty(field)) {
                    // const combinedErrors = errors[field].join(" ");
                    // if (field === "supplier_type") {
                    //   setFieldError("option", combinedErrors);
                    // }
                  }
                }
                toast.error(response?.error?.data?.message, {
                  position: "top-center",
                  autoClose: 3000,
                });
              } else {
                toast.error(response?.error?.data?.message, {
                  position: "top-center",
                  autoClose: 3000,
                });
              }
            }
          }
        } catch (error) {}
      }}
    >
      {({ handleSubmit, setFieldValue, values }) => (
        <>
          <div className="cs-ps-modal-header">
            <div className="row">
              <div className="col-md-12">
                <p className="cp-ps-form-heading">Schedule and prices</p>
                <p className="cp-ps-note">
                  Here are the detail of price option, this can be managed later
                  anytime from product management
                </p>
                <div className="d-flex cp-ps-private-header">
                  <p className="cp-ps-form-heading m-0">
                    {productDetail?.product_title}
                  </p>
                  <div className="cp-ps-private-header-span">By Vehicle</div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-9">
              <Form onSubmit={handleSubmit}>
                <Row className="cp-ps-date-select-section mb-3">
                  <Col md={6}>
                    <Form.Group controlId="startDate">
                      <Form.Label className="cp-ps-form-label">
                        Start date
                      </Form.Label>
                      <InputGroup className="sp-igroup-date">
                        <Flatpickr
                          // data-theme={props.isDark}
                          className={`cp-ps-flatpickr-container `}
                          name="startDate"
                          placeholder="Set Date"
                          options={{
                            altInput: true,
                            altFormat: "M d, Y",
                            dateFormat: "Y-m-d",
                            static: true,
                            // enableTime: true,
                            disableMobile: true,
                            // maxDate: values.endDate,
                            // minDate: new Date(),
                            // defaultHour: 18, // Set to 18 for 6:00 PM
                            // minDate: new Date()
                          }}
                          ref={flatpickrRef}
                          value={values.startDate}
                          onChange={([date]) => {
                            setFieldValue(
                              "startDate",
                              date ? new Date(date) : null
                            );
                          }}
                        />
                        <span
                          className="cp-ps-calender-icon"
                          onClick={() => flatpickrRef.current.flatpickr.open()}
                        >
                          {getCalendarSvg()}
                        </span>
                        <ErrorMessage
                          name="startDate"
                          component="div"
                          className="text-danger"
                        />
                      </InputGroup>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="endDate">
                      <Form.Label className="cp-ps-form-label">
                        End date <span>(optional)</span>
                      </Form.Label>
                      <InputGroup className="sp-igroup-date">
                        <Flatpickr
                          // data-theme={props.isDark}
                          className={`cp-ps-flatpickr-container `}
                          name="endDate"
                          placeholder="End Date"
                          options={{
                            altInput: true,
                            altFormat: "M d, Y",
                            dateFormat: "Y-m-d",
                            static: true,
                            // enableTime: true,
                            disableMobile: true,
                            minDate: values.startDate,
                            // defaultHour: 18, // Set to 18 for 6:00 PM
                            // minDate: new Date()
                          }}
                          ref={flatpickrRef2}
                          value={values.endDate}
                          onChange={([date]) => {
                            setFieldValue(
                              "endDate",
                              date ? new Date(date) : null
                            );
                          }}
                        />
                        <span
                          className="cp-ps-calender-icon"
                          onClick={() => flatpickrRef2.current.flatpickr.open()}
                        >
                          {getCalendarSvg()}
                        </span>
                      </InputGroup>
                    </Form.Group>
                  </Col>
                </Row>

                <div className="discount-container text-center">
                  <h5 className="text-success mb-3">Recommended Discount</h5>
                  <div className="slider-wrapper">
                    <span className="slider-label">10%</span>
                    <input
                      type="range"
                      className="form-range custom-slider"
                      min="10"
                      max="90"
                      value={discount}
                      onChange={(e) => setDiscount(e.target.value)}
                    />
                    <span className="slider-label">90%</span>
                  </div>
                  <p className="mt-2 selected-discount">
                    Selected Discount: {discount}%
                  </p>
                </div>

                <div className="cp-ps-step-2-tiered-pricing-table cp-ps-step-2-tiered-pricing-table-two">
                  <Row className="cp-ps-step-2-table-header cp-ps-step-2-table-header-two mx-0">
                    <Col md={2} className="ps-0">
                      Max pax
                    </Col>
                    <Col md={3} className="ps-0">
                      Retail price
                    </Col>
                    <Col md={2} className="ps-0">
                      Discount price
                    </Col>
                    <Col md={3} className="ps-0">
                      Commission
                    </Col>
                    <Col md={2} className="ps-0">
                      Your share
                    </Col>
                  </Row>

                  {rows.map((row, index) => (
                    <Row
                      key={index}
                      className="cp-ps-step-2-table-row cp-ps-step-2-table-row-two"
                    >
                      <Col
                        md={2}
                        className="d-flex align-items-center ps-0 max-pax-input-group"
                      >
                        <Select
                          name="maxPax"
                          options={numberOptions}
                          placeholder="0"
                          className="p-0 "
                          value={numberOptions.find(
                            (option) => option.value === row.maxPax
                          )}
                          onChange={(selectedOption) => {
                            handleChange(index, "maxPax", selectedOption.value);
                          }}
                        />
                      </Col>
                      <Col md={3} className="d-flex align-items-center ps-0">
                        <Form.Control
                          type="number"
                          placeholder="Retail price"
                          value={row.retailPrice}
                          onKeyDown={(e) => {
                            if (
                              e.key === "-" ||
                              e.key === "+" ||
                              e.key === "e"
                            ) {
                              e.preventDefault(); // Prevent negative, plus, or exponential notation input
                            }
                          }}
                          onChange={(e) =>
                            handleChange(index, "retailPrice", e.target.value)
                          }
                        />
                      </Col>
                      <Col md={2} className="d-flex align-items-center ps-0">
                        <Form.Control
                          type="number"
                          placeholder="Discount Price"
                          value={
                            row.retailPrice
                              ? (
                                  row.retailPrice -
                                  (row.retailPrice * discount) / 100
                                ).toFixed(2)
                              : ""
                          }
                          onChange={(e) =>
                            handleChange(index, "discountPrice", e.target.value)
                          }
                          disabled
                        />
                      </Col>
                      <Col md={3} className="d-flex align-items-center ps-0">
                        <Form.Control
                          type="number"
                          placeholder="Commission"
                          value={
                            row.retailPrice
                              ? (
                                  (
                                    row.retailPrice -
                                    (row.retailPrice * discount) / 100
                                  ).toFixed(2) *
                                  (parseFloat(
                                    productDetail?.product_categories[0]
                                      ?.category_commission?.default_commission
                                  ) /
                                    100)
                                ).toFixed(2)
                              : ""
                          }
                          onChange={(e) =>
                            handleChange(index, "commission", e.target.value)
                          }
                          disabled
                        />
                      </Col>
                      <Col md={2} className="d-flex align-items-center ps-0">
                        <Form.Control
                          type="number"
                          placeholder="Your share"
                          value={
                            row.retailPrice
                              ? (
                                  (
                                    row.retailPrice -
                                    (row.retailPrice * discount) / 100
                                  ).toFixed(2) -
                                  (
                                    (
                                      row.retailPrice -
                                      (row.retailPrice * discount) / 100
                                    ).toFixed(2) *
                                    (parseFloat(
                                      productDetail?.product_categories[0]
                                        ?.category_commission
                                        ?.default_commission
                                    ) /
                                      100)
                                  ).toFixed(2)
                                ).toFixed(2)
                              : ""
                          }
                          onChange={(e) =>
                            handleChange(index, "yourShare", e.target.value)
                          }
                          disabled
                        />
                      </Col>
                    </Row>
                  ))}
                  {formError && <div className="text-danger">{formError}</div>}
                </div>
                <Form.Group
                  controlId="tieredPricing"
                  className="cp-ps-time-switch-container"
                >
                  <FormCheck
                    type="switch"
                    id="enable-tiered-pricing"
                    label="Live availability"
                    checked={liveAvailability}
                    onChange={() => {
                      setLiveAvailability(!liveAvailability);
                    }}
                  />
                </Form.Group>
                {liveAvailability && (
                  <>
                    <Form.Group controlId="">
                      <Form.Label className="cp-ps-form-label">
                        Select the days these prices apply
                      </Form.Label>
                      <div className="cp-pc-attraction-modal-input-checkbox d-flex align-items-center cp-ps-radio-input border-0 h-0">
                        <Form.Check
                          type="checkbox"
                          name={"options"}
                          // value={value}
                          checked={selectedDays}
                          onChange={() => {
                            setSelectedDays(!selectedDays);
                            if (!selectedDays) {
                              handleSelectAllDays(values, setFieldValue);
                            } else {
                              handleDeselectAllDays(values, setFieldValue);
                            }
                            // setFieldValue("daysApply", selectedDays);
                          }}
                          className={"radio-button mt-0 mb-0 cp-ps-radio"}
                        />
                        <p className=" m-0 p-0 ">Select All</p>
                      </div>

                      <div className="d-flex flex-column cp-ps-step-2-days-checkboxes-wrapper">
                        <div className="cp-ps-step-2-days-checkboxes">
                          {weeklyData?.data?.map((day) => (
                            <div
                              key={day.day_id}
                              name
                              className={`cp-ps-day-check-box ${
                                values?.daysApply?.includes(day?.day_id)
                                  ? "cp-ps-day-selected"
                                  : ""
                              }`}
                              onClick={() =>
                                handleDayClick(
                                  day.day_id,
                                  values,
                                  setFieldValue
                                )
                              }
                            >
                              {day?.day_name}
                            </div>
                          ))}
                        </div>
                        <ErrorMessage
                          name="daysApply"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Form.Group>

                    <Form.Group controlId="timeApply">
                      <Form.Label className="cp-ps-form-label">
                        Select the time these prices apply{" "}
                        <span>(optional)</span>
                      </Form.Label>
                      {timeSlots?.map((slot, index) => {
                        // Get selected start times from all slots except the current one
                        const selectedTimes = timeSlots
                          .filter((s) => s.id !== slot.id)
                          .map((s) => s.start_time);

                        // Filter the available time options for the current slot
                        const availableTimeOptions = timeOptions.filter(
                          (option) => !selectedTimes.includes(option.value)
                        );

                        return (
                          <InputGroup
                            className="cp-ps-timeslot-main mb-3 d-flex align-items-center"
                            key={slot.id}
                          >
                            {/* Start Time Select */}
                            <Select
                              name={`startTime-${slot.id}`}
                              options={availableTimeOptions}
                              placeholder="Select start time"
                              className="p-0 form-control cp-ps-timeslot-select ms-0"
                              value={availableTimeOptions.find(
                                (option) => option.value === slot.start_time
                              )}
                              onChange={(selectedOption) =>
                                handleStartTimeChange(slot.id, selectedOption)
                              }
                              components={{
                                Control: ({ children, ...props }) => (
                                  <components.Control {...props}>
                                    {children}
                                    <div className="select-icon">
                                      <Icon icon="ic:baseline-keyboard-arrow-down" />
                                    </div>
                                  </components.Control>
                                ),
                              }}
                            />

                            {/* Delete Icon */}
                            <img
                              src={DeleteIcon}
                              alt="delete-icon"
                              className="ms-2"
                              onClick={() => handleRemoveTimeSlot(slot.id)} // Use id to remove the correct slot
                              style={{ cursor: "pointer" }} // Optional: Add a pointer cursor for better UX
                            />
                          </InputGroup>
                        );
                      })}
                      <p onClick={addTimeSlot} className="add-time-slot">
                        + Add a time slot
                      </p>
                      {timeError && (
                        <div className="text-danger mb-2">{timeError}</div>
                      )}
                    </Form.Group>
                  </>
                )}
                <div
                  className={`w-100 d-flex align-items-center justify-content-end`}
                >
                  <button
                    type="submit"
                    className="submit-btn"
                    disabled={isLoading}
                  >
                    Save {isLoading && <Spinner size="sm" />}
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </>
      )}
    </Formik>
  );
};

export default ByVehicleModal;
